import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

import { getLMSStudentName } from "../lib/scorm";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const STATIC_URL = `${BACKEND_URL}/api/static`;

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
 const [user, setUser] = useState(null);
 const [progress, setProgress] = useState(null);
 const [loading, setLoading] = useState(true);

 const fetchProgress = useCallback(async (uid) => {
 if (!uid) return;
 try {
 const res = await axios.get(`${API}/progress/${uid}`);
 setProgress(res.data);
 } catch (e) {
 console.error("Failed to fetch progress", e);
 }
 }, []);

 const registerUser = useCallback(async (name) => {
 const res = await axios.post(`${API}/users`, { name });
 const u = res.data;
 setUser(u);
 localStorage.setItem("steadfast_user", JSON.stringify(u));
 await fetchProgress(u.id);
 return u;
 }, [fetchProgress]);

 // Load user from localStorage on mount
 useEffect(() => {
 (async () => {
 try {
 const lmsName = getLMSStudentName();
 const stored = localStorage.getItem("steadfast_user");
 
 if (stored) {
 try {
 const u = JSON.parse(stored);
 if (lmsName && u.name !== lmsName) {
 localStorage.removeItem("steadfast_user");
 } else {
 setUser(u);
 setLoading(false);
 return;
 }
 } catch (e) {
 localStorage.removeItem("steadfast_user");
 }
 }

 if (lmsName) {
 await registerUser(lmsName);
 }
 } catch (e) {
 localStorage.removeItem("steadfast_user");
 } finally {
 setLoading(false);
 }
 })();
 }, [registerUser]);

 useEffect(() => {
 if (user?.id) fetchProgress(user.id);
 }, [user, fetchProgress]);

 const refreshProgress = () => user?.id && fetchProgress(user.id);

 const logout = () => {
 localStorage.removeItem("steadfast_user");
 setUser(null);
 setProgress(null);
 };

 return (
 <UserContext.Provider value={{ user, progress, loading, registerUser, refreshProgress, logout }}>
 {children}
 </UserContext.Provider>
 );
};

export const useUser = () => {
 const ctx = useContext(UserContext);
 if (!ctx) throw new Error("useUser must be used within UserProvider");
 return ctx;
};
